import { FormConverter } from '../../../utilities/form-mapper/form-converter';
import { Config } from '../config.model';
import { ConfigModelForm } from './config-model.form';

export class ConfigModelMapper extends FormConverter<
  Partial<Config>,
  ConfigModelForm
> {
  public toFormModel(data: Config): ConfigModelForm {
    const form = new ConfigModelForm();

    form.workingYear = data.workingYear ?? null;
    form.startDate = data.startDate ?? null;
    form.endDate = data.endDate ?? null;

    return form;
  }

  public toObject(form: ConfigModelForm): Config {
    return {
      workingYear: form.workingYear!,
      startDate: this.setDateWithTime(form.startTime!, form.startDate!),
      endDate: this.setDateWithTime(form.endTime!, form.endDate!),
    };
  }

  private setDateWithTime(time: Date, date: Date): Date {
    date.setHours(time.getHours());
    date.setMinutes(time.getMinutes());
    date.setSeconds(0);
    return date;
  }
}
